var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimezone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.1V16.5L18.6 17.3M21 16.5C21 18.7091 19.2091 20.5 17 20.5C14.7909 20.5 13 18.7091 13 16.5C13 14.2909 14.7909 12.5 17 12.5C19.2091 12.5 21 14.2909 21 16.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68675 14.1451L3.59494 13.0435C3.6983 12.9839 3.8196 12.9631 3.9369 12.9851L7.6914 13.6878C7.99995 13.7455 8.28478 13.508 8.28338 13.1941L8.26876 9.90445C8.26836 9.81507 8.29193 9.72722 8.33701 9.65005L10.2317 6.40621C10.3303 6.23739 10.3215 6.02658 10.2091 5.8666L7.01892 1.32568M18.0002 3.35905C12.5002 6.00004 15.5 9.50004 16.5002 10C18.3773 10.9384 20.9876 11 20.9876 11C20.9958 10.8344 21 10.6677 21 10.5C21 4.97715 16.5228 0.5 11 0.5C5.47715 0.5 1 4.97715 1 10.5C1 16.0228 5.47715 20.5 11 20.5C11.1677 20.5 11.3344 20.4959 11.5 20.4877",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/Timezone.b1b535c1.svg";
export { ForwardRef as ReactComponent };